<template>
  <div class="welcome-banner">
    <div class="row mt-5">
      <div class="col-md-12 mb-5">
        <h4 id="v-step-2">Übersicht</h4>
      </div>
      <div class="col-md-12 dashboard-dates">
        <div class="col-lg-4">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Geburtsdatum ist erforderlich.',
                }"
              >
                <v-text-field
                  label="Datum ab"
                  placeholder="TT/MM/JJJJ"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  v-model="formattedDate"

                  
                ></v-text-field>
               
              </ValidationProvider>
            </template>
            <v-date-picker
              locale="de-at"
              :first-day-of-week="1"
              v-model="date"
              :max="minDate"
              no-title
              scrollable
              @change="changeDateFormat()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                ABBRECHEN
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          
        </div>

        <div class="col-lg-4">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :return-value.sync="toDate"
            transition="scale-transition"
            offset-y
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Geburtsdatum ist erforderlich.',
                }"
              >
                <v-text-field
                  label="Datum bis"
                  placeholder="TT/MM/JJJJ"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  v-model="formattedToDate"
                ></v-text-field>
               
              </ValidationProvider>
            </template>
            <v-date-picker
              locale="de-at"
              :first-day-of-week="1"
              v-model="toDate"
              :max="maxDate"
              no-title
              scrollable
              @change="changetoDateFormat()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu1 = false">
                ABBRECHEN
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu1.save(toDate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
    </div>
    <div class="loading-content-div my-5" v-if="loading">
      <pulse-loader
        :loading="loading"
        :color="color"
        :size="size"
      ></pulse-loader>
    </div>
    <div v-if="!loading">
      <div class="row mt-5" v-if="notifications.length">
        <div class="col-md-12 mb-5">
          <!-- <h4 id="v-step-2">Inbox</h4> -->
        </div>
        <div class="col-md-8 bookings-list-status">
          <div class="inbox-listing">
          <ul>
            <li v-for="(notification, i) in notifications" :key="'grdf' + i">             
              <div @click="getNotificationsDetails(notification)">
                <div v-if="notification.type == 'Ein neues Produkt wurde vom Händler hinzugefügt'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Neue Produkte
                  </span>
                  <span v-else>
                    Neues Produkt
                  </span>
                </div>

                <div v-if="notification.type == 'Handler geändert Allgemeine Geschäftsbedingungen'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  Allgemeine Geschäftsbedingungen geändert
                </div>

                <div v-if="notification.type == 'Handler geändert Produktbeschreibung'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Geänderte Produktbeschreibungen
                  </span>
                  <span v-else>
                    Geänderte Produktbeschreibung
                  </span>
                </div>

                <div v-if="notification.type == 'Handler geändert Produktbild'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Geänderte Produktbilder
                  </span>
                  <span v-else>
                    Geändertes Produktbild
                  </span>
                </div>

                <div v-if="notification.type == 'Handler geändert Produktname'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Geänderte Produkte
                  </span>
                  <span v-else>
                    Geändertes Produkt
                  </span>
                </div>

                <div v-if="notification.type == 'Produkt gelöscht'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Gelöschte Produkte
                  </span>
                  <span v-else>
                    Gelöschtes Produkt
                  </span>
                </div>

                <div v-if="notification.type == 'Neue Registrierung eines Händlers'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Neue Händlerregistrierungen
                  </span>
                  <span v-else>
                    Neue Händlerregistrierung
                  </span>
                </div>

                <div v-if="notification.type == 'Neue Registrierung eines Kunden'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Neue Kundenregistrierungen
                  </span>
                  <span v-else>
                    Neue Kundenregistrierung
                  </span>
                </div>

                <div v-if="notification.type == 'Handler geändert Standard Mehrwertsteuersatz (%)'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  <span v-if="notification.count > 1">
                    Geänderte Standard-Mehrwertsteuersätze
                  </span>
                  <span v-else>
                    Geänderter Standard-Mehrwertsteuersatz
                  </span>
                </div>
                <div v-if="notification.type == 'Statusänderung des Produktes'">
                  <span class="notification_count">{{ notification.count }} </span> 
                 
                  <span v-if="notification.count > 1">
                    Statusänderungen von Produkten
                  </span>
                  <span v-else>
                    Statusänderung eines Produktes
                  </span>
                </div>
                <div v-if="notification.type == 'Support Antwort'">
                  <span class="notification_count">{{ notification.count }} </span> 
                 
                  <span v-if="notification.count > 1">
                    Support Antworten
                  </span>
                  <span v-else>
                    Support Antwort
                  </span>
                </div>
                <div v-if="notification.type == 'Support-Nachricht'">
                  <span class="notification_count">{{ notification.count }} </span> 
                  
                  <span v-if="notification.count > 1">
                    Support-Nachrichten
                  </span>
                  <span v-else>
                    Support-Nachricht
                  </span>
                </div>
              </div>              
            </li>
          </ul>
          </div>
        </div>
      </div>
      <div class="row graph-revanu mt-5">
        <div class="col-md-12">
          <ul>
            <li>
              <div id="v-step-5">
                Umsatz brutto
                <span
                  >€
                  {{revenue ? revenue : "0,00" }}</span
                >
              </div>
            </li>
            <li>
              # Bestellungen
              <span>{{ orders ? orders : "0" }}</span>
            </li>
            <li>
              Durchschnittlicher Einkaufswert
              <span>€ {{ avarage_purchase ? avarage_purchase : "0,00" }}</span>
            </li>
            <li>
              Vertriebsprovision netto
              <span>€ {{ sales_commission ? sales_commission : "0,00" }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="row graph-revanu mt-5">
        <div class="col-md-12">
          <ul>
            <li>
              <div id="v-step-5">
                Neue Kunden
                <span
                  >
                  {{customer_count ? customer_count : "0" }}</span
                >
              </div>
            </li>
            <li>
              Kundenwachstum
              <span>{{ customer_growth ? customer_growth : "0" }}%</span>
            </li>
            <li>
              Neue Händler
              <span> {{ dealer_count ? dealer_count : "0" }}</span>
            </li>
            <li>
              Händlerwachstum
              <span> {{ dealer_growth ? dealer_growth : "0" }}%</span>
            </li>
          </ul>
          
        </div>
      </div>
      <div class="row graph-revanu mt-5">
        <div class="graph col-md-12">
          <div class="ind-wrapper">
            <div class="bookin-ind">
              <div
                style="height: 15px; width: 15px; background-color: #3d5a80"
              ></div>
              <p>Umsatz</p>
              <line-chart
              :chart-data="progressCharData"
              :options="options"
              :height="300"
              :width="800"
              v-if="progressCharData"></line-chart>
            </div>
            
          </div>
        </div>
      </div>
      <div class="row graph-revanu mt-5">
        <div class="graph col-md-12">
          
          <div class="ind-wrapper">
            <div class="bookin-ind">
              <div
                style="height: 15px; width: 15px; background-color: #ff9419"
              ></div>
              <p>Bestellungen</p>
              <line-chart
                :chart-data="bookingCharData"
                :options="options"
                :height="300"
                :width="800"
                v-if="bookingCharData"></line-chart>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px;">
        <div class="col-md-12 mb-5">
          <h4 id="v-step-2">Top-Produkte</h4>
        </div>
        <v-simple-table class="record-table">
          <thead>
            <tr>
              <th class="text-center align-middle" width="5%">
                Seriennummer
              </th>
              <th
                width="25%"
                class="text-center align-middle">
                Produktname
              </th>
              
              <th class="text-center align-middle" width="25%">Einheit</th>
              <th class="text-center align-middle" width="25%">Preis pro Einheit</th>
              <th class="text-center align-middle" width="25%">Menge</th>
              <th class="text-center align-middle" width="25%">Preis</th>
              
            </tr>
          </thead>
        
          <tbody v-if="topProducts.length">
            <tr v-for="(product, i) in topProducts" :key="product.id">
              <td
                class="align-middle clickable-td"
                
              >
                {{ i + 1 }}
              </td>
              <td
                class="align-middle clickable-td"
              >
                {{
                  product.product_name.length > 60
                    ? product.product_name.substr(0, 60) + "..."
                    : product.product_name
                }}
              </td>
              <td
                v-if="product.unit"
                class="align-middle clickable-td text-center"
              >
                {{product.quantity_measure}} {{
                  product.unit ? product.unit : "-"
                }}
              </td>

              <td
                v-if="product.unit_price"
                class="align-middle clickable-td text-center"
              >
                {{
                  product.unit_price ? product.unit_price : "0,00"
                }} €
              </td>
              <td
                v-if="product.quantity"
                class="align-middle clickable-td text-center"
              >
                {{
                  product.quantity ? product.quantity : "0"
                }} 
              </td>
              <td
                v-if="product.total"
                class="align-middle clickable-td text-center"
              >
                {{
                  product.total ? product.total.toFixed(2)
                            .replace(".", ","): "0,00"
                }} €
              </td>

              <td
                v-else
                class="align-middle clickable-td text-center"
              >
                -
              </td>
              
              
            </tr>
          </tbody>
          <tbody v-else-if="loading_products" class="loading-tbody">
            <td colspan="10">
              Wird geladen...
              <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </td>
          </tbody>
          <tbody v-else class="loading-tbody">
            <tr>
              <td colspan="10">Keine Einträge gefunden</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
    <!-- <center>
    	<img src="/media/images/book/welcome-dashboard.jpg">
      <h2>Willkommen bei Gustoreich</h2>

      <div>
        <span style="font-size: 16px">Aktuell sind keine Dokumente verfügbar</span>
      </div>
    </center> -->
  </div>
</template>

<style scoped>
h2{
  font-family: 'ubuntu';
}
</style>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { mapGetters } from "vuex";
import adminAPI from "@/api/admin";
import LineChart from "@/components/admin/helper/charts/line";
import moment from "moment";
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "dashboard",
  components: {
    LineChart,
    PulseLoader,
  },
  data() {
    return {
      loading: true,
      menu: false,
      menu1: false,
      minDate: new Date(Date.now())
        .toISOString()
        .substr(0, 10),
      maxDate: moment().endOf('month').format('YYYY-MM-DD'),
      notifications: [],
      revenue: '0,00',
      date: "",
      toDate: "",
      avarage_purchase: '0,00',
      sales_commission: '0,00',
      orders: 0,
      graphType: "Last 7 days",
      formattedDate: "",
      formattedToDate: "",
      progressCharData: [],
      bookingCharData: [],
      topProducts: [],
      customer_count: 0,
      customer_growth: 0,
      dealer_count: 0,
      dealer_growth: 0,
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function (tooltipItems, data) {
              return tooltipItems.label + ": " + tooltipItems.yLabel;
            },
          },
        },
        /*scales: {
          xAxes: [{
            ticks: {
              autoSkip: false
            }
          }]
        },*/
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handleChart,
      },
    }
  },
  // watch: {
  //   graphType: function (val) {
  //     this.getNotifications();
  //   },
  // },
  computed: {
    ...mapGetters([
      "currentUser",
    ]),
  },
  created() {
     this.formattedDate = moment().startOf('month').format('DD/MM/YYYY');
     this.formattedToDate  = moment().endOf('month').format('DD/MM/YYYY');
     this.date = moment().startOf('month').format('YYYY-MM-DD');
     this.toDate = moment().endOf('month').format('YYYY-MM-DD');
     this.getNotifications();
  },
  methods: {
    getNotificationsDetails(notification){

      if (notification.type == "Statusänderung des Produktes" || 
        notification.type == "Handler geändert Produktbeschreibung" || notification.type == "Handler geändert Produktbild" || 
        notification.type == "Änderung von Produktdaten" || notification.type == "Handler geändert Produktname" || notification.type == "Handler geändert Produktname,Produktbeschreibung" 
        || notification.type == "Handler geändert Produktbeschreibung,Produktbild" || notification.type == 'Handler geändert Produktname,Produktbild'
        || notification.type == 'Handler geändert Produktname,Produktbeschreibung,Produktbild') {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'edit-product/'+ notification.product_id});
      }
      if (notification.type == "Ein neues Produkt wurde vom Händler hinzugefügt") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'dealer-product-details/'+ notification.send_by+'/'+notification.product_id+'?redirect=all-listing'});
       
      }
      if (notification.type == "Produkt-Kontingent hinzugefügt" || notification.type == "Ein neues Produkt wurde vom Händler") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'edit-product/'+ notification.product_id});
      }
      if (notification.type == "Support-Nachricht") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'support-response/'+ btoa(btoa(notification.support_id))});
      }
      if (notification.type == "Support Antwort") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'support-response/'+ btoa(btoa(notification.support_id))});
      }
      if (notification.type == "Handler geändert Allgemeine Geschäftsbedingungen" || notification.type == "Handler geändert Standard Mehrwertsteuersatz (%)" || notification.type == "Handler geändert Standard Mehrwertsteuersatz (%),Allgemeine Geschäftsbedingungen") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'edit-general-setting/'+ notification.send_by});
      }
      if (notification.type == "Neue Registrierung eines Händlers") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'edit-producer/'+ notification.send_by});
      }
      if (notification.type == "Neue Registrierung eines Kunden") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'customer-details/'+ notification.send_by});
      }
      // if (notification.message == "Änderung von Händlerdaten") {
      //   this.readStatusUpdate(notification.id);
      //   this.$router.push({ path: 'edit-producer/'+ notification.send_by});
      // }
    },
    readStatusUpdate (id) {
      let data = {
         id: [id],
         
        };
      adminAPI
        .readStatusUpdate(data)
        .then((response) => {
          if (response.status == "success") {
          
          }
        });
    },
    changeDateFormat(){
      this.formattedDate = moment(String(this.date)).format("DD/MM/YYYY");
      var fromDate = this.formattedDate;
      fromDate = fromDate.split("/");
      var minDate = new Date( fromDate[2], fromDate[1] - 1, fromDate[0]);
      this.maxDate = moment().endOf('month').format('YYYY-MM-DD');
      
      this.getNotifications();        
    },
    readNotification(type){
      let data = {
         admin_id: this.currentUser.id,
         type: type
        };
      adminAPI
        .readNotificationStatusByType(data)
        .then((response) => {
          if (response.status == "success") {
            this.loading= false
            
          }
        });
    },
    changetoDateFormat(){
      this.formattedToDate = moment(String(this.toDate)).format("DD/MM/YYYY");
      this.getNotifications();
      
    },
    getNotifications () {
      this.loading = true;
      // old code
      // let data = {
      //    admin_id: this.currentUser.id,
      //    graph_type: this.graphType,
      //    from_date: this.date,
      //    to_date: this.toDate
      //   };

      // new code
      var formDate = moment(this.formattedDate, 'DD/MM/YYYY').format("YYYY-MM-DD");
      var formToDate = moment(this.formattedToDate, 'DD/MM/YYYY').format('YYYY-MM-DD');

      let data = {
         admin_id: this.currentUser.id,
         graph_type: this.graphType,
         from_date: formDate,
         to_date: formToDate
        };
      adminAPI
        .dashboardNotification(data)
        .then((response) => {
          if (response.status == "success") {
            this.loading = false;
            let keyArr = [];
            let revenueArr = [];
            let bookingArr = [];
            this.revenue = response.order_data.revenue.toFixed(2)
                          .replace(".", ",");
            this.orders = response.order_data.orders;
            this.avarage_purchase = response.order_data.avarage_purchase.toFixed(2)
                          .replace(".", ",");
            this.sales_commission = response.seles_commission.toFixed(2)
                          .replace(".", ",");
            this.notifications = response.notification;
           
            this.topProducts = response.top_products;
            /*if (response.top_products.length) {
              response.top_products.forEach((item) => {
                
                
              });
            }*/
            this.customer_count = response.customer_count.user_count;
            this.customer_growth = response.customer_count.growth.toFixed(2)
                          .replace(".", ",");
            this.dealer_count = response.dealer_count.dealer_count;
            this.dealer_growth = response.dealer_count.growth.toFixed(2)
                          .replace(".", ",");
            if (response.graph_data.length) {
              response.graph_data.forEach((item) => {
                keyArr.push(item.key);
                revenueArr.push(item.total_amount.toFixed(2));
                bookingArr.push(item.total_orders);
              });
            }
            this.progressCharData = {
              labels: keyArr,
              datasets: [
                {
                  label: "Umsatz",
                  borderColor: ["#3d5a80"],
                  pointBackgroundColor: "white",
                  borderWidth: 2,
                  pointBorderColor: "#3d5a80",
                  data: revenueArr,
                },
              ],      
            };
            this.bookingCharData = {
              labels: keyArr,
              datasets: [
                {
                  label: "Buchungen",
                  borderColor: ["#ff9419"],
                  pointBackgroundColor: "white",
                  borderWidth: 2,
                  pointBorderColor: "#ff9419",
                  data: bookingArr,
                }, 
              ],      
            };
          }
        }, (error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("userCheckoutDetails");
            this.$store.dispatch(LOGOUT).then(() => {
              setTimeout(() => {
                // this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$router.push({ name: "login" });
              }, 1000);
            });
          }
        });
    }
  },
};
</script>
<style type="text/css" scoped>
.dashboard-dates {
  display: inline-flex;
}
.bookings-list-status ul {
  list-style: none;
  margin-right: 20px;
  padding: 0 !important;
  margin-top: 0;
}

.bookings-list-status ul li {
  background-color: #f1f1f1;
  margin-bottom: 10px;
  padding: 13px 20px;
  border-radius: 5px;
  border-left: 3px solid #3d5a80;
}

  .graph-revanu ul li {
  background-color: #f1f1f1;
  border-left: 3px solid #3d5a80;
  border-radius: 5px;
  width: calc(33.33% - 10px);
  padding: 20px 15px;
}

.graph-revanu ul {
  display: flex;
  list-style: none;
  padding: 0 !important;
  justify-content: space-between;
  margin-right: 0 !important;
  column-gap: 15px;
}

.graph-revanu ul li span {
  display: block;
  font-size: 20px;
  font-weight: bold;
  color: #e57a00;
}

.graph-revanu ul li span {
  word-break: break-all;
}
.ind-wrapper {
  display: flex;
  align-items: center;
}

.ind-wrapper div {
  display: flex;
  align-items: center;
  margin-right: 18px;
}

.ind-wrapper div p {
  margin-bottom: 0;
  font-size: 12px;
}

.ind-wrapper div div {
  margin-right: 10px;
}
.notification_count {
    font-size: 20px;
    font-weight: bold;
    color: #e57a00;
}
</style>
